import z from 'zod';

export enum TradeDirection {
  LONG = 'long',
  SHORT = 'short',
}

export const tradeDirectionSchema = z.enum(TradeDirection);
